export default __webpack_public_path__ + "static/ayvakit-logo-hero-advsm-d78c72176719943f5a00d95222935fa5.png";